import { Component, OnInit, ViewChild } from "@angular/core";
import { of } from "rxjs";
import { Observable } from "rxjs-compat";
import { map } from "rxjs/operators";

@Component({
  selector: "ngx-autocomplete-input",
  template: ``,
  styleUrls: ["./autocomplete-input.component.scss"],
})
export class AutocompleteInputComponent implements OnInit {
  constructor() {}

  options: string[];
  filteredOptions$: Observable<string[]>;

  @ViewChild("autoInput") input;

  ngOnInit() {
    this.options = ["Option 1", "Option 2", "Option 3"];
    this.filteredOptions$ = of(this.options);
  }

  private filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.options.filter((optionValue) =>
      optionValue.toLowerCase().includes(filterValue)
    );
  }

  getFilteredOptions(value: string): Observable<string[]> {
    return of(value).pipe(map((filterString) => this.filter(filterString)));
  }

  onChange() {
    this.filteredOptions$ = this.getFilteredOptions(
      this.input.nativeElement.value
    );
  }

  onSelectionChange($event) {
    this.filteredOptions$ = this.getFilteredOptions($event);
  }
}
